import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {compose} from 'redux';
import * as Yup from 'yup';
import {get, post} from '../../../../../../api/api';
import {
  uriConfirmActivationCode,
  uriCreateUser,
  uriRequestActivationCode,
} from '../../../../../../api/endpoints';

import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../../../components/forms';
import Header2 from '../../../../../../components/headers/header2';
import {Column, Row} from '../../../../../../components/layout';
import {addToGlobalStyles, addToWizard} from '../../../../../../store/actions';
import {strings} from '../../../../../../util/strings';
import {
  censorEmail,
  censorPhone,
  createGUID,
} from '../../../../../../util/utility';
import AppErrorMessage from '../../../../../../components/app-error-message';
import NewErrorMessage from '../../../../../../components/new-error-message';
import {Icons} from '../../../../../../util/icons';
import colors from '../../../../../../util/colors';
import Header1 from '../../../../../../components/headers/header1';

interface EnterCodeProps {
  wizard: any;
  addToWizard(value: any): void;
  valid: boolean;
  setValid(value: any): void;
  nextStep(): void;
  labels: typeof strings.pt.register;
  messageLabels: typeof strings.pt.messages;
  globalStyles: any;
}

function EnterCode({
  addToWizard,
  wizard,
  valid,
  setValid,
  nextStep,
  labels,
  messageLabels,
  globalStyles,
}: EnterCodeProps) {
  const [guid, setGuid] = useState(
    (wizard &&
      wizard.activateRegistration &&
      wizard.activateRegistration.guid) ||
      ''
  );

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(messageLabels?.requiredField),
  });
  const [submitting, setSubmitting] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const [invalidCode, setInvalidCode] = useState(false);
  const [alreadyExisting, setAlreadyExisting] = useState(false);
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState(false);
  const [showResendConfirmation, setShowResendConfirmation] = useState(false);
  const [disableResend, setDisableResend] = useState(false);

  const history = useHistory();

  const {selectedContact, selectedContactType} = wizard.dataValidation;

  const requestActivationCode = async () => {
    const guid = createGUID();
    setDisableResend(true);
    try {
      await post(
        uriRequestActivationCode(),
        JSON.stringify({
          senderType: selectedContactType,
          destination: selectedContact,
          sessionGuid: guid,
          name: wizard.insuranceValidation.name,
          buId: wizard?.user?.buId,
        })
      );

      addToWizard({activateRegistration: {guid}});
      setInvalidCode(false);
      setShowResendConfirmation(true);
      setGuid(guid);
    } catch (e: any) {
    } finally {
      setDisableResend(false);
    }
  };

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
    dateInput?: boolean
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    if (!dateInput) {
      var icon: HTMLElement = elem.nextSibling as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }

    if (
      dateInput &&
      (elem.tagName.includes('svg') || elem.tagName.includes('path'))
    ) {
      var icon: HTMLElement = elem as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }
  };

  const defineIconFunctions = (icon: HTMLElement, fieldNamePar: any) => {
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons(true);
      };
      icon.onmouseout = function () {
        setHoverErrorIcons(false);
      };
    }
  };

  const confirmCode = async (code: string) => {
    return await get(uriConfirmActivationCode(code, guid));
  };

  useEffect(() => {
    //requestActivationCode(); este codigo ja não é utilizado aqui, é utilizado onclick do submit do passo anterior no accountdata
  }, []);

  return (
    <Column className="enter-code-container">
      <AppForm
        initialValues={{code: ''}}
        validationSchema={validationSchema}
        onValidation={(valid) => setValid(valid)}
        onSubmit={async (values) => {
          setShowResendConfirmation(false);
          setSubmitting(true);
          setInvalidCode(false);
          if (
            selectedContactType === 'SMS' ||
            (selectedContactType === 'EMAIL' && !!!wizard.user)
          ) {
            // Ativacao feita por SMS ou por email no caso do utilizador ter contacto do RIOS e ter selecionado qual contacto quer usar
            try {
              const response = await confirmCode(values.code);

              if (response) {
                nextStep();
              } else {
                setInvalidCode(true);
                (formikContext as any).setFieldValue('code', '');
              }
            } catch (e: any) {
              setInvalidCode(true);
            } finally {
              setSubmitting(false);
            }
          } else {
            // Ativacao feita por email Para utilizadores novos ou sem contacto no RIOS
            try {
              const response = await confirmCode(values.code);

              const tenantAlias = process.env
                .REACT_APP_DEFAULT_TENANT_ALIAS as string;

              if (response) {
                await fetch(uriCreateUser(), {
                  method: 'POST',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    X_MYADV_API_KEY: tenantAlias,
                  },
                  body: JSON.stringify(wizard.user),
                })
                  .then((res: any) => {
                    if (!res.ok) {
                      return res.text().then((text: any) => {
                        if (text?.includes('UserAlreadyExisting')) {
                          setAlreadyExisting(true);
                        }
                        if (text?.includes('30003')) {
                          setInvalidCredentials(true);
                        }
                      });
                    } else {
                      history.push('/registo-completo');
                      return res.json();
                    }
                  })
                  .catch((e: any) => {
                    if (e.status === 500) {
                      (formikContext as any).setFieldError(
                        'email',
                        labels?.emailPassword_existingUsername
                      );
                    }
                  });
              } else {
                setInvalidCode(true);
                (formikContext as any).setFieldValue('code', '');
              }
            } catch (e: any) {
              setInvalidCode(true);
            } finally {
              setSubmitting(false);
            }
          }
        }}>
        <Header2 className="enter-code-header">{`${
          labels?.activation_subTitle
        } ${
          selectedContactType === 'SMS'
            ? censorPhone(selectedContact)
            : selectedContactType === 'EMAIL'
            ? censorEmail(selectedContact)
            : ''
        }`}</Header2>
        <Column
          name="enter-code-code-validation"
          style={{position: 'relative'}}>
          <AppFormField
            name="code"
            placeholder={labels?.activation_activationCodePlaceholder}
            handleFormikContext={(formik) => {
              if (
                !!!formikContext ||
                formik.errors !== (formikContext as any).errors
              ) {
                setFormikContext(formik);
              }
            }}
            onMouseOver={(e) => {
              defineOnMouseFunctions(e, 'code');
            }}
          />
          {hoverErrorIcons && (
            <AppErrorMessage
              message={
                (formikContext &&
                  (formikContext as any).errors &&
                  (formikContext as any).errors.code) ||
                messageLabels?.requiredField
              }
              className="insurance-validation-pop-up-error-message"
            />
          )}
          {invalidCode && (
            <NewErrorMessage
              iconName={Icons.ALERT_PROBLEM}
              colorIcon={colors.alertRed}
              text={labels?.register_wrongActivationCode}></NewErrorMessage>
          )}
          {alreadyExisting && (
            <NewErrorMessage
              iconName={Icons.ALERT_PROBLEM}
              colorIcon={colors.alertRed}
              text={
                labels?.register_usernameAlreadyRegistered
              }></NewErrorMessage>
          )}
          {invalidCredentials && (
            <NewErrorMessage
              iconName={Icons.ALERT_PROBLEM}
              colorIcon={colors.alertRed}
              text={labels?.register_invalidCredentials}></NewErrorMessage>
          )}
        </Column>
        {showResendConfirmation && (
          <Row className="app-center enter-code-resend-code-message">
            <Header2 className="enter-code-header">{`${labels?.changePassword_codeSent}`}</Header2>
          </Row>
        )}
        <Row className="app-center enter-code-resend-code">
          <Link
            className={
              disableResend
                ? 'activate-registration-anchors-disable'
                : 'activate-registration-anchors'
            }
            to={history.location.pathname}
            style={{
              color: globalStyles?.primaryColor,
            }}
            onClick={async () =>
              !disableResend && (await requestActivationCode())
            }>
            {labels?.activation_sendNewCode}
          </Link>
        </Row>
        <Row className="app-center">
          <AppFormSubmitButton
            title={labels?.activation_buttonText}
            disabled={!valid || submitting}
            className="stepper-continue-button enter-code-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

const mapStateToProps = ({strings, wizard, user, globalStyles}: any) => ({
  labels: strings.value.pt.register,
  messageLabels: strings.value.pt.messages,
  wizard: wizard.value,
  user: user.value,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(EnterCode));

//export default EnterCode;
